import { 
  collection, 
  getDocs, 
  query, 
  where 
} from 'firebase/firestore';
import { db } from '../firebase';

// Get admin profile picture for public display
export const getAdminProfilePicture = async () => {
  try {
    // Check if we have a cached version that's less than 5 minutes old
    const cacheKey = 'adminProfilePicture';
    const cacheTimeKey = 'adminProfilePictureTime';
    const now = Date.now();
    const fiveMinutes = 5 * 60 * 1000;
    
    const cachedURL = localStorage.getItem(cacheKey);
    const cachedTime = localStorage.getItem(cacheTimeKey);
    
    if (cachedURL && cachedTime && (now - parseInt(cachedTime)) < fiveMinutes) {
      return cachedURL;
    }
    
    // Query users collection for the admin user
    const usersQuery = query(
      collection(db, 'users'), 
      where('profilePictureURL', '!=', null)
    );
    const usersSnapshot = await getDocs(usersQuery);
    
    if (usersSnapshot.empty) {
      return null;
    }
    
    // Get the first user with a profile picture (should be the admin)
    const userDoc = usersSnapshot.docs[0];
    const userData = userDoc.data();
    const profilePictureURL = userData.profilePictureURL || null;
    
    // Cache the result
    if (profilePictureURL) {
      localStorage.setItem(cacheKey, profilePictureURL);
      localStorage.setItem(cacheTimeKey, now.toString());
    }
    
    return profilePictureURL;
  } catch (error) {
    console.error('Error getting admin profile picture:', error);
    return null;
  }
};

// Get admin birthday for public display
export const getAdminBirthday = async () => {
  try {
    // Query users collection for the admin user
    const usersQuery = query(
      collection(db, 'users'), 
      where('birthday', '!=', null)
    );
    const usersSnapshot = await getDocs(usersQuery);
    
    if (usersSnapshot.empty) {
      return null;
    }
    
    // Get the first user with a birthday (should be the admin)
    const userDoc = usersSnapshot.docs[0];
    const userData = userDoc.data();
    
    return userData.birthday || null;
  } catch (error) {
    console.error('Error getting admin birthday:', error);
    return null;
  }
};
